/**
 * /settings — opens the Settings pocket at the page a link names. Old links
 * (`?tab=billing`, `?tab=memory`, …) map through the page registry; Stripe
 * returns here after checkout and from the billing portal. Closing goes back
 * to the canvas.
 */
import { useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SettingsPocket } from "@/components/settings/settings-pocket";
import {
  currentSettingsPlatform,
  settingsStackFor,
  settingsTargetFromTab,
  type SettingsTarget,
} from "@/components/settings/settings-navigation";

export function SettingsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [stack, setStack] = useState<readonly SettingsTarget[]>(() =>
    settingsStackFor(
      settingsTargetFromTab(searchParams.get("tab")),
      currentSettingsPlatform(),
    ),
  );
  const handleClose = useCallback(() => navigate("/"), [navigate]);
  return (
    <div className="h-screen w-screen bg-canvas" data-testid="settings-page">
      <SettingsPocket
        open
        stack={stack}
        onStackChange={setStack}
        onClose={handleClose}
      />
    </div>
  );
}
